import { gql } from "apollo-boost";

export const fragments = {
  service: gql`
    fragment ServiceService on Service {
      id
      serviceType
      status
      holdType
      holdReason
      submittedAt
      postedTurnaround
      postedTurnaroundDate
      structureType
      certifiedReview
      options {
        serviceLevel
        fullDetailPackage
        includeElevations
        rush
        rushMaterialTakeoff
        structuralCalculations
        pdfStructuralDrawings
        consultationRequest
        drawingDepth
        pdfDrawings
      }
      productionSteps {
        id
        stepType
        startedAt
        completedAt
        user {
          id
          name
          email
        }
      }
    }
  `
};

export default gql`
  query ServiceQuery($id: ID!) {
    service(id: $id) {
      ...ServiceService
    }
  }
  ${fragments.service}
`;



// WEBPACK FOOTER //
// ./src/queries/Service.js